import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  root: ({ selected }: { selected: boolean }) => ({
    backgroundColor: "inherit",
    borderLeft: selected ? "none" : "",
    borderRight: selected ? "none" : "",
    border: selected ? `1px solid ${theme.palette.primary.light}` : "none",
  }),
  selectedText: {
    fontWeight: 600,
    color: colors.white,
    overflowWrap: "break-word",
  },
  text: {
    color: colors.white,
    overflowWrap: "break-word",
  },
  icon: {
    minWidth: 32,
    color: colors.white,
  },
}));

export default useStyles;
